var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert';
import { StaffService } from '../../../../services/workload/staff.service';
import { OverviewTotal } from '../../../../logic/workload/overview-total';
var TeamMemberListComponent = /** @class */ (function () {
    function TeamMemberListComponent(staffService, toastr) {
        this.staffService = staffService;
        this.toastr = toastr;
        this.team = [];
        this.archiveUserSubscription = new Subscription();
        this.viewModel = {
            headers: {
                name: 'Name',
                surname: 'Surname',
                email: 'Email',
                role: 'Role',
                assignedTeam: 'Team assigned',
                archive: 'Archive'
            },
            archiveAltText: 'Archive User'
        };
    }
    TeamMemberListComponent.prototype.ngOnDestroy = function () {
        if (this.archiveUserSubscription)
            this.archiveUserSubscription.unsubscribe();
    };
    TeamMemberListComponent.prototype.triggerArchiveProcess = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.staffService.getOverview(userId).toPromise().then(function (staffOverview) {
                            var overviewTotal = new OverviewTotal(staffOverview).total();
                            var staffDisplayName = staffOverview.staff.staffName;
                            swal({
                                title: "Archive " + staffDisplayName + "?",
                                text: staffDisplayName + " has " + overviewTotal + " record" + (overviewTotal !== 1 ? 's' : '') + " assigned to them",
                                icon: 'warning',
                                buttons: [true, 'Archive!']
                            }).then(function (willArchive) {
                                if (willArchive) {
                                    _this.archiveUser(userId, staffDisplayName);
                                }
                            });
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TeamMemberListComponent.prototype.archiveUser = function (userId, staffDisplayName) {
        var _this = this;
        this.team.map(function (team) {
            var user = team.teamMembers.filter(function (x) { return x.id === userId; })[0];
            if (user) {
                var index = team.teamMembers.indexOf(user);
                team.teamMembers.splice(index, 1);
            }
        });
        this.staffService.archiveStaff(userId).toPromise().then(function (success) {
            _this.toastr.success(staffDisplayName + " has been archived", 'Success!', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
        }, function (error) {
            _this.toastr.error(staffDisplayName + " has not been archived", 'Error', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
        });
    };
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], TeamMemberListComponent.prototype, "team", void 0);
    TeamMemberListComponent = __decorate([
        Component({
            selector: 'team-member-list',
            template: require('./team-member-list.component.html'),
            styles: [require('./team-member-list.component.scss')]
        }),
        __metadata("design:paramtypes", [StaffService,
            ToastrService])
    ], TeamMemberListComponent);
    return TeamMemberListComponent;
}());
export { TeamMemberListComponent };
//# sourceMappingURL=data:application/json;base64,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